import React from 'react';
import { Provider as StoreProvider } from 'react-redux';
import {store} from './redux/store';
import { App } from 'antd';
import RoutesApp  from './router';
import { ConfigProvider } from 'antd';
import es_ES from 'antd/es/locale/es_ES';
import GlobalStyles from '@app/assets/styles/global';
// import 'moment/locale/es';
const defaultData = {
  borderRadius: 6,
  colorPrimary: '#2E2D75',
  Button: {
    colorPrimary: '#2E2D75',
  },
};
const AppProvider = ({ children }) => {
  const [data, setData] = React.useState(defaultData);
  return (
    <StoreProvider store={store}>
      <ConfigProvider locale={es_ES}
      theme={{
        token: {
          colorPrimary: data.colorPrimary,
          borderRadius: data.borderRadius,
        },
        components: {
          Button: {
            colorPrimary: data.Button?.colorPrimary,
            algorithm: data.Button?.algorithm,
          },
        },
      }}
      >
        {children}
      </ConfigProvider>
    </StoreProvider>
  );
}
const AppPage = () => {
  //const { message, notification, modal } = App.useApp();
  // message.success('Good!');
  // notification.info({ message: 'Good' });
  // modal.warning({ title: 'Good' });
  // ....
  // other message, notification, modal static function
  return <>
        <AppProvider>
          <GlobalStyles/>
          <RoutesApp />
        </AppProvider>
    </>;
};

const AppRoot = () => <App>
  <AppPage></AppPage>
</App>

export default AppRoot;